const config = {
  prd: {
    live: false
  },

  dev: {
    skip_mandatory_fields: false,
    use_firebase_emulator: true
  },

  event: {
    title: 'Corvallis Contra Weekend',
    title_with_year: 'Corvallis Contra Weekend 2026', // must match backend config
    location: 'Corvallis, Oregon',
    date: 'Feb 13-15, 2026',
    timezone: 'America/Los_Angeles'
  },

  // UPDATE DESCRIPTION & TIMES:
  calendar: {
    title: 'Corvallis Contra Weekend',
    description: 'Orb Weavers & Wake Up Robin - https://corvallisfolklore.org/home/ccw',
    location: 'Corvallis, Oregon',
    start: '2026-02-13T19:00:00-07:00', // ISO 8601 format
    end: '2026-02-15T15:00:00-07:00' // ISO 8601 format
  },

  contacts: {
    info: 'cfs.dance.weekend@gmail.com',
    tech: 'ash@pdxcontra.org',
    // housing: 'housing@example.com'
  },

  external_links: {
    more_info: 'corvallisfolklore.org/home/ccw',
    policies: {
      covid: 'corvallisfolklore.org/home/ccw-faq/',
      safety: 'corvallisfolklore.org/home/dance-safety-policy/'
    }
  },

  nametags: {
    include_pronouns: true,
    include_last_name: false
  },

  static_pages: {
    enabled: false,
    components: [], // These must exist in src/components/Static
  },

  registration: {
    waitlist_mode: false,
    show_preregistration: true,
    admission_quantity_max: 4,
    fields: { // Order of form fields
      contact: ['first', 'last', 'nametag', 'pronouns', 'email', 'emailConfirmation', 'phone', 'address', 'apartment', 'city', 'state', 'zip', 'country'],
      misc: ['share', 'carpool', 'volunteer', 'scholarship', 'comments']
    }
  },

  admissions: {
    mode: 'sliding-scale', // sliding-scale|fixed|tiered
    sliding_scale: {
      cost_range: [100, 150],
      cost_default: 100
    },
    fixed: {
      cost: 200
    },
    tiered: {
      earlybird_cutoff: '2025-11-10', // last day to get early pricing
    }
  },

  payments: {
    processor: 'paypal', // stripe|paypal - also must set in backend config
    // payment_due_date: 'Example Payment Due Date',
    // direct_payment_url: 'example.com/directpayment', // electronic payment option to pay remaining balance after selecting deposit or check payment
    cover_fees_checkbox: true,
    show_payment_summary: false, // show summary of costs in payment section
    deposit: {
      enabled: false,
      amount: 50 // ignored if disabled
    },
    donation: {
      enabled: true,
      max: 999 // ignored if disabled
    },
    checks: {
      allowed: true, // If false, the below fields are ignored
      show_postal_address: true, // If false, shows contact email
      payee: 'Corvallis Folklore Society',
      address: ['CCW', 'c/o Corvallis Folklore Society', 'PO Box 1690', 'Corvallis OR 97339']
    }
  }
};

export default config;